import React from 'react';
import { motion } from 'framer-motion';

const Manifesto: React.FC = () => {
  return (
    <section id="philosophy" className="py-24 bg-brand-black border-b-2 border-brand-gray relative">
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        
        <div className="relative">
           {/* Visual block with topographic background */}
           <div className="w-full aspect-square bg-brand-darkgray relative overflow-hidden border border-brand-gray">
              {/* Topographic background image */}
              <div 
                className="absolute inset-0 opacity-[0.12] bg-cover bg-center"
                style={{ backgroundImage: 'url(/images/about-topographic.png)' }}
              />
              {/* Radial gradient overlay */}
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-brand-red/10 via-transparent to-transparent" />
              
              <div className="h-full w-full border border-brand-gray flex flex-col justify-between p-8 relative z-10">
                 <div className="text-6xl font-sans font-black text-brand-white/5">E3</div>
                 <div className="space-y-3">
                   <div className="flex items-center gap-3">
                     <span className="w-2 h-2 bg-brand-red" />
                     <span className="font-mono text-xs text-brand-red uppercase tracking-widest">Embedded</span>
                   </div>
                   <div className="flex items-center gap-3">
                     <span className="w-2 h-2 bg-brand-red" />
                     <span className="font-mono text-xs text-brand-red uppercase tracking-widest">Essential</span>
                   </div>
                   <div className="flex items-center gap-3">
                     <span className="w-2 h-2 bg-brand-red" />
                     <span className="font-mono text-xs text-brand-red uppercase tracking-widest">Engineered</span>
                   </div>
                 </div>
                 <div className="text-right text-6xl font-sans font-black text-brand-white/5">PRO</div>
              </div>
              
              {/* Floating accent */}
              <motion.div 
                className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-brand-red text-black font-bold font-sans text-lg px-6 py-3 border-2 border-black"
                animate={{ rotate: [2, -2, 2] }}
                transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
              >
                E3 METHODOLOGY
              </motion.div>
           </div>
        </div>

        <div>
          <h2 className="text-5xl md:text-7xl text-brand-white mb-8 leading-[0.9]">
            GROWTH ISN'T A
            <br />
            <span className="text-brand-red">COINCIDENCE</span>.
            <br />
            IT'S A SYSTEM.
          </h2>
          
          <div className="space-y-6 font-mono text-gray-400 text-base leading-relaxed">
            <p>
              Traditional marketing is soft. It asks nicely. It waits for permission. 
              It hopes for the best.
            </p>
            <p className="border-l-4 border-brand-red pl-6 py-2 text-brand-white font-medium">
              We engineered E3 — Embedded, Essential, Engineered — because enterprise 
              marketing demands more than tactics. It demands architecture.
            </p>
            <p>
              Every campaign we build is deeply <span className="text-brand-white">embedded</span> in your revenue operations. 
              We focus ruthlessly on what's <span className="text-brand-white">essential</span> to your bottom line. 
              And every system is <span className="text-brand-white">engineered</span> for compounding returns.
            </p>
          </div>

          <div className="mt-12 grid grid-cols-2 gap-4">
             <div className="border border-brand-gray p-5 hover:bg-brand-gray/30 transition-colors">
                <h3 className="text-brand-red font-bold mb-2 text-sm tracking-wider">SPEED</h3>
                <p className="text-xs font-mono text-gray-500 leading-relaxed">Campaigns deployed in hours, not weeks. Market reaction is immediate.</p>
             </div>
             <div className="border border-brand-gray p-5 hover:bg-brand-gray/30 transition-colors">
                <h3 className="text-brand-red font-bold mb-2 text-sm tracking-wider">PRECISION</h3>
                <p className="text-xs font-mono text-gray-500 leading-relaxed">Data-driven targeting. Every rupee tracked to revenue.</p>
             </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
